import { keepPreviousData, useQuery } from "@tanstack/react-query";
import i18n from "i18n";
import UserNotification from "util/UserNotification";
import { TEAMS_QUERY_KEY, loadTeamsPaginated } from "../api/teams";
const useTeamsPaginated = (pagination) => useQuery({
  queryKey: [...TEAMS_QUERY_KEY, "paginated", pagination],
  queryFn: () => loadTeamsPaginated(pagination).catch((error) => {
    UserNotification.error(
      i18n.t("teams_paginated.loading_failed", { ns: "enterprise_security", error: String(error) })
    );
    throw error;
  }),
  placeholderData: keepPreviousData,
  retry: false
});
export default useTeamsPaginated;
